$(window).scroll(function(){
  //Sticky Bar
  $('.menu-desk').addClass('stuck');		
  if ( $(this).scrollTop() > 400){
    $('.menu-desk,.mob-nav').addClass('sticky-nav');
    $('.menu-desk,.mob-nav').addClass('stuck');
  }else{
    $('.menu-desk,.mob-nav').removeClass('sticky-nav');
    $('.menu-desk,.mob-nav').removeClass('stuck');
  }     	
});


//lets talk sidebar
$('[contact-us]').on('click', function() {
  showOverlay();
  $('.lets-t').addClass('open');
})

function closeTalk() {
  hideOverlay();
  $('.lets-t').removeClass('open');
}
function menuMob() {    
  $('.menu-mob').addClass('open');
} 
function closeMob() {    
  $('.menu-mob').removeClass('open');
}
//overlay
function showOverlay(){
  $('body').append("<div class='overlay'></div>");
  $("#MainContent,header").addClass("blurry");
}
function hideOverlay(){
  $(".overlay").remove();
  $("#MainContent,header").removeClass("blurry");
}
$('body').on('click', '.overlay', function() {
  hideOverlay();
  $(".drawer").removeClass("open");
});
// SmoothScroll
$('[href*="#"]').smoothscroll({
  duration:  600,
  easing: 'swing',
  offset: -148,
  focus: false,
});